import { Switch } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { safeExtractFromObject } from '../../helpers/helpers';
import Colors from '../../constants/Colors';

export default function OnTraccrSwitch({
  value,
  onChange,
  style = {},
  title,
  textStyle = {},
  containerStyle = {},
  disabled = false,
  loading = false,
  unCheckedChildren,
  checkedChildren,
  defaultChecked,
  useRightView = false,
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const isLeftView = !useRightView && !settings?.uxRedesignPt1;
  const formattedTextStyle = settings?.uxRedesignPt1
    ? {
      fontSize: 14,
      padding: 0,
      color: Colors.REDESIGN_PRIMARY_TEXT,
      textColor: 'black',
      fontWeight: '400',
      fontFamily: 'open-sans',
      ...textStyle,
    }
    : textStyle;

  return (
    <div style={{ display: 'flex', alignItems: 'center', ...containerStyle }}>
      {isLeftView && (
        <span style={{ marginRight: 10, ...formattedTextStyle }}>{title}</span>
      )}
      <Switch
        className={settings?.uxRedesignPt1 ? 'ontraccr-switch' : ''}
        checked={value}
        onChange={onChange}
        style={style}
        unCheckedChildren={unCheckedChildren}
        checkedChildren={checkedChildren}
        disabled={disabled}
        loading={loading}
        defaultChecked={defaultChecked}
      />
      {!isLeftView && (
        <span style={{ marginLeft: 10, ...formattedTextStyle }}>{title}</span>
      )}
    </div>
  );
}

OnTraccrSwitch.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.shape({}),
  title: PropTypes.string,
  textStyle: PropTypes.shape({}),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  unCheckedChildren: PropTypes.string,
  checkedChildren: PropTypes.string,
  defaultChecked: PropTypes.bool,
  useRightView: PropTypes.bool,
  containerStyle: PropTypes.shape({}),
};

OnTraccrSwitch.defaultProps = {
  style: {},
  title: '',
  textStyle: {},
  containerStyle: {},
  disabled: false,
  loading: false,
  unCheckedChildren: null,
  checkedChildren: null,
  defaultChecked: false,
  useRightView: false,
};
